import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const accountGroupRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/account-group',
  component: lazyRouteComponent(() => import('@/pages/account-group/account-group-page')),
  validateSearch: (search: Record<string, unknown>) => {
    return {
      ...search,
      name: search.name as string | undefined,
    };
  },
});

export const accountGroupDetailRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/account-group/$id',
  component: lazyRouteComponent(() => import('@/pages/account-group/detail-account-group-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
      tabs: search.tabs as string | undefined,
    };
  },
});
